import Agreement from './agreement';
import Template from './template';

export default {
  Agreement,
  Template,
};
